import { render, staticRenderFns } from "./CardTypeForm.vue?vue&type=template&id=119bef3c&scoped=true&"
import script from "./CardTypeForm.vue?vue&type=script&lang=js&"
export * from "./CardTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./CardTypeForm.vue?vue&type=style&index=0&id=119bef3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119bef3c",
  null
  
)

export default component.exports